module.exports = __webpack_public_path__ + "assets/img/picc.88dd908b.png";